export default {
  fieldNames: {
      preference: "Preferencia",
      partNumber: "Número de parte",
      reorderPoint: "Punto de reorden",
      reorderQuantity: "Cantidad a reordenar",
      minimumStock: "Stock mínimo",
      analystName: "Nombre del analista",
      purchasingOfficer: "Ingeniero de compras",
  },
  analyst: "Analista",
  applicant: "Solicitante",
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/Stages/analystView.js